module.exports = __webpack_public_path__ + "static/media/powered_01.1b51b702.png";